module.exports = __webpack_public_path__ + "img/inthenews2.c25b01ab.jpg";